import React, { createContext, useState } from "react";
import { useMemo } from "react";

export const MinerPageContext = createContext({
  tableGroup: {},
  setTableGroup: (tableGroup) => {},
  detailGroup: {},
  setDetailGroup: (detailGroup) => {},
  siteSelectedName: "",
  setSiteSelectedName: (siteSelectedName) => {},
  groupSelectedName: "",
  setGroupSelectedName: (groupSelectedName) => {},
  selectedSerials: [],
  setSelectedSerials: (selectedSerials) => {},
  currentSerial: [],
  setCurrentSerial: (selectedSerial) => {},
  untagMinersDialogOpen: false,
  setUntagMinersDialogOpen: (untagMinersDialogOpen) => {},
  tagsListDialogOpen: false,
  setTagsListDialogOpen: (untagMinersDialogOpen) => {},
  groupFilters: {},
  setGroupFilters: (groupFilters) => {},
  MinerConfigurationModalOpen: false,
  setMinerConfigurationModalOpen: (
    MinerConfigurationModalOpen
  ) => {},
  whichMinerConfigurationForm: "",
  setWhichMinerConfigurationForm: (
    whichMinerConfigurationForm
  ) => {},
  customizationModalOpen: false,
  setCustomizationModalOpen: (customizationModalOpen) => {},
  customPowerModalOpen: false,
  setCustomPowerModalOpen: (customPowerModalOpen) => {},
  retuneModalOpen: false,
  setRetuneModalOpen: (retuneModalOpen) => {},
  setUpgradeModalOpen: (setUpgradeModalOpen) => {},
  upgradeModalOpen: false,
  jobs: [],
  setJobs: (jobs) => {},
  poolsData: [],
  setPoolsData: (poolsData) => {},
  psuData: [],
  setPsuData: (psuData) => {},
  openPSUDialog: false,
  setOpenPSUDialog: (openPSUDialog) => {},
  fansData: [],
  setFansData: (fansData) => {},
  openFansDialog: false,
  setOpenFansDialog: (openFansDialog) => {},
});

export const MinerPageContextProvider = (props) => {
  const [tableGroup, setTableGroup] = useState({});
  const [detailGroup, setDetailGroup] = useState({});
  const [jobs, setJobs] = useState([]);
  const [siteSelectedName, setSiteSelectedName] =
    useState("");
  const [groupSelectedName, setGroupSelectedName] =
    useState("");
  const [selectedSerials, setSelectedSerials] = useState(
    []
  );
  const [currentSerial, setCurrentSerial] = useState(
    []
  );
  const [untagMinersDialogOpen, setUntagMinersDialogOpen] =
    useState(false);
  const [tagsListDialogOpen, setTagsListDialogOpen] = 
    useState(false)
  const [groupFilters, setGroupFilters] = useState({});
  const [
    customizationModalOpen,
    setCustomizationModalOpen,
  ] = useState(false);
  const [
    MinerConfigurationModalOpen,
    setMinerConfigurationModalOpen,
  ] = useState(false);
  const [
    whichMinerConfigurationForm,
    setWhichMinerConfigurationForm,
  ] = useState("");
  const [customPowerModalOpen, setCustomPowerModalOpen] =
    useState(false);
  const [retuneModalOpen, setRetuneModalOpen] =
    useState(false);
  const [upgradeModalOpen, setUpgradeModalOpen] =
    useState(false);
  const [poolsData, setPoolsData] = useState([]);
  const [psuData, setPsuData] = useState([]);
  const [fansData, setFansData] = useState([]);
  const [openPoolsDialog, setOpenPoolsDialog] =
    useState(false);
  const [openPSUDialog, setOpenPSUDialog] = useState(false);
  const [openFansDialog, setOpenFansDialog] = useState(false);

  const contextValue = useMemo(() => {
    return {
      jobs,
      setJobs,
      tableGroup,
      setTableGroup,
      detailGroup,
      setDetailGroup,
      siteSelectedName,
      setSiteSelectedName,
      groupSelectedName,
      setGroupSelectedName,
      selectedSerials,
      setSelectedSerials,
      currentSerial,
      setCurrentSerial,
      untagMinersDialogOpen,
      setUntagMinersDialogOpen,
      tagsListDialogOpen,
      setTagsListDialogOpen,
      groupFilters,
      setGroupFilters,
      MinerConfigurationModalOpen,
      setMinerConfigurationModalOpen,
      whichMinerConfigurationForm,
      setWhichMinerConfigurationForm,
      customizationModalOpen,
      setCustomizationModalOpen,
      customPowerModalOpen,
      setCustomPowerModalOpen,
      retuneModalOpen,
      setRetuneModalOpen,
      upgradeModalOpen,
      setUpgradeModalOpen,
      poolsData,
      setPoolsData,
      psuData,
      setPsuData,
      fansData,
      setFansData,
      openPoolsDialog,
      setOpenPoolsDialog,
      openPSUDialog,
      setOpenPSUDialog,
      openFansDialog,
      setOpenFansDialog,
    };
  }, [
    jobs,
    setJobs,
    tableGroup,
    detailGroup,
    siteSelectedName,
    groupSelectedName,
    selectedSerials,
    currentSerial,
    setCurrentSerial,
    untagMinersDialogOpen,
    setUntagMinersDialogOpen,
    tagsListDialogOpen,
    setTagsListDialogOpen,
    groupFilters,
    setGroupFilters,
    MinerConfigurationModalOpen,
    setMinerConfigurationModalOpen,
    whichMinerConfigurationForm,
    setWhichMinerConfigurationForm,
    customizationModalOpen,
    setCustomizationModalOpen,
    customPowerModalOpen,
    setCustomPowerModalOpen,
    retuneModalOpen,
    setRetuneModalOpen,
    upgradeModalOpen,
    setUpgradeModalOpen,
    poolsData,
    setPoolsData,
    psuData,
    setPsuData,
    fansData,
    setFansData,
    openPoolsDialog,
    setOpenPoolsDialog,
    openPSUDialog,
    setOpenPSUDialog,
    openFansDialog,
    setOpenFansDialog,
  ]);

  return (
    <MinerPageContext.Provider value={contextValue}>
      {props.children}
    </MinerPageContext.Provider>
  );
};
